// extracted by mini-css-extract-plugin
export default {"UnitCard":"UnitCard_UnitCard__HQ1AP","UnitCardAdded":"UnitCard_UnitCardAdded__NkYni"};